module.exports = __webpack_public_path__ + "static/media/location-current.25c45de0.svg";